import { parseBooleanEnvFlag } from './env.js'

export const isAdsterraEnabled = (env = import.meta.env) => parseBooleanEnvFlag(
  env?.VITE_ADSTERRA_ENABLED,
  false,
)

export const isAdsenseEnabled = (env = import.meta.env) => parseBooleanEnvFlag(
  env?.VITE_ADSENSE_ENABLED,
  true,
)

export const resolveAdsterraTimeoutMs = (env = import.meta.env) => {
  const timeoutMs = Number(env?.VITE_ADSTERRA_TIMEOUT_MS)
  return Number.isInteger(timeoutMs) && timeoutMs > 0 && timeoutMs <= 2147483647 ? timeoutMs : 20000
}

export const resolveAdProviderPriority = (env = import.meta.env) => {
  const configured = String(env?.VITE_AD_PROVIDER_PRIORITY || env?.VITE_NAVBAR_AD_PROVIDER_PRIORITY || '').split(',').map(value => value.trim().toLowerCase())
  return [...new Set([...configured, 'google', 'adsterra'])].filter(provider => (
    provider === 'google' ? isAdsenseEnabled(env) : provider === 'adsterra' && isAdsterraEnabled(env)
  ))
}

// Build-time visual preview. Never enables real advertising delivery.
export const isAdsMockEnabled = (env = import.meta.env) => parseBooleanEnvFlag(
  env?.VITE_ADS_MOCK_ENABLED,
  false,
)
